import { translations as ca } from './locales/ca';
import { translations as de } from './locales/de';
import { translations as en } from './locales/en';
import { translations as es } from './locales/es';
import { translations as eu } from './locales/eu';
import { translations as fr } from './locales/fr';
import { translations as gl } from './locales/gl';
import { translations as it } from './locales/it';
import { translations as nl } from './locales/nl';
import { translations as pt } from './locales/pt';
import * as z from 'zod';

const locales = { ca, de, en, es, eu, fr, gl, it, nl, pt };

export const portalLocales = ['ca', 'de', 'en', 'es', 'eu', 'fr', 'gl', 'it', 'nl', 'pt'] as const;

/** Portal locales extended with BCP47 variants for standalone donation integrations */
export const portalLocalesExtended = [
	'ca',
	'ca-ES',
	'de',
	'de-DE',
	'en',
	'en-EN',
	'en-US',
	'en-GB',
	'es',
	'es-ES',
	'eu',
	'eu-ES',
	'fr',
	'fr-FR',
	'gl',
	'gl-ES',
	'it',
	'it-IT',
	'nl',
	'nl-NL',
	'pt',
	'pt-PT',
	'pt-BR',
] as const;

// Reexport for typescript to be satisfied
export type PortalLocaleExtended = (typeof portalLocalesExtended)[number];

/** Portal locales extended with BCP47 variants for standalone donation integrations */
export const portalLocaleExtendedToPortalLocale: Record<PortalLocaleExtended, PortalLocale> = {
	'ca': 'ca',
	'ca-ES': 'ca',
	'de': 'de',
	'de-DE': 'de',
	'en': 'en',
	'en-EN': 'en', // although not a valid BCP47 code, some browsers return this for English
	'en-US': 'en',
	'en-GB': 'en',
	'es': 'es',
	'es-ES': 'es',
	'eu': 'eu',
	'eu-ES': 'eu',
	'fr': 'fr',
	'fr-FR': 'fr',
	'gl': 'gl',
	'gl-ES': 'gl',
	'it': 'it',
	'it-IT': 'it',
	'nl': 'nl',
	'nl-NL': 'nl',
	'pt': 'pt',
	'pt-PT': 'pt',
	'pt-BR': 'pt',
};

export type PortalLocale = (typeof portalLocales)[number];

export const getTranslation = (locale: PortalLocale): (typeof locales)['es'] => locales[locale];

export type I18n = ReturnType<typeof getTranslation>;

export const contactFormSchema = z.object({
	name: z.string(),
	email: z.string(),
	phone: z.string().optional(),
	category: z.union([
		z.literal('merchant'),
		z.literal('ngo'),
		z.literal('donor'),
		z.literal('press'),
		z.literal('newsletter'),
		z.literal('other'),
	]),
	message: z.string(),
	checkbox: z.object({
		type: z.literal('termsAndConditions'),
		checked: z.boolean(),
		text: z.string(),
		label: z.string(),
	}),
	captchaToken: z.string(),
	language: z.enum(portalLocales),
});

export type ContactForm = z.infer<typeof contactFormSchema>;
